import React, { useEffect } from 'react';

export default function ContactUs() {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fadeIn');
        }
      });
    }, { threshold: 0.2 });

    const items = document.querySelectorAll('.contact-fade');
    items.forEach((item, idx) => {
      item.style.transitionDelay = `${idx * 0.15}s`;
      observer.observe(item);
    });

    return () => observer.disconnect();
  }, []);

  const s = {
    section: {
      padding: '8rem 6%',
      backgroundColor: '#2B1509', // Espresso dark background
      color: '#F4EAE0', // offWhite text
    },
    container: {
      maxWidth: '1000px',
      margin: '0 auto',
      display: 'grid',
      gap: '4rem',
    },
    contentWrapper: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '4rem',
    },
    title: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: 'clamp(2.5rem, 4vw, 3.5rem)',
      lineHeight: 1.1,
      marginBottom: '1rem',
      color: '#F4EAE0',
    },
    body: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '1rem',
      lineHeight: 1.7,
      color: 'rgba(244,234,224,0.8)',
      marginBottom: '2rem',
    },
    contactInfo: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.9rem',
      color: '#D8B79B', // latte
      marginBottom: '1rem',
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
    },
    inputGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
    },
    label: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.8rem',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      color: '#C7AE97', // sand
    },
    input: {
      width: '100%',
      padding: '1rem',
      backgroundColor: 'transparent',
      border: '1px solid rgba(216,183,155,0.3)', // latte border
      color: '#F4EAE0',
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '1rem',
      outline: 'none',
    },
    textarea: {
      width: '100%',
      padding: '1rem',
      backgroundColor: 'transparent',
      border: '1px solid rgba(216,183,155,0.3)',
      color: '#F4EAE0',
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '1rem',
      outline: 'none',
      minHeight: '150px',
      resize: 'vertical',
    },
    cta: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.85rem',
      fontWeight: 600,
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      color: '#F4EAE0',
      backgroundColor: '#D96D29', // Sun orange
      border: 'none',
      padding: '1.2rem 2.5rem',
      cursor: 'pointer',
      transition: 'background 0.3s ease',
      alignSelf: 'flex-start',
    }
  };

  return (
    <>
      <style>{`
        @media (max-width: 768px) {
          .contact-content { grid-template-columns: 1fr !important; }
        }
        .contact-form-elements input:focus, .contact-form-elements textarea:focus {
          border-color: #D96D29 !important;
        }
      `}</style>
      <section id="contact" style={s.section}>
        <div style={s.container}>
          
          <div className="contact-content" style={s.contentWrapper}>
            <div className="contact-fade preFade">
              <h2 style={s.title}>Get In Touch</h2>
              <p style={s.body}>
                Whether you are looking to place a bulk order of green beans for your roastery, 
                or seeking a reliable supplier of roasted coffee for your cafes across the USA, 
                our team is ready to assist.
              </p>
              
              <div style={s.contactInfo}>
                <strong>Email:</strong> Info@savanasips.net
              </div>
              <div style={s.contactInfo}>
                <strong>HQ:</strong> Nairobi, Kenya
              </div>
              <div style={s.contactInfo}>
                <strong>US Hub:</strong> Seattle, Washington
              </div>
            </div>

            <div className="contact-fade preFade contact-form-elements">
              <form style={s.form} onSubmit={e => e.preventDefault()}>
                <div style={s.inputGroup}>
                  <label style={s.label}>Company Name</label>
                  <input style={s.input} type="text" placeholder="Your Business" />
                </div>
                <div style={s.inputGroup}>
                  <label style={s.label}>Email Address</label>
                  <input style={s.input} type="email" placeholder="you@company.com" />
                </div>
                <div style={s.inputGroup}>
                  <label style={s.label}>Message / Inquiry</label>
                  <textarea style={s.textarea} placeholder="Estimated volume, roasted vs green, etc."></textarea>
                </div>
                <button 
                  style={s.cta}
                  onMouseEnter={e => e.target.style.backgroundColor = '#A63C1E'}
                  onMouseLeave={e => e.target.style.backgroundColor = '#D96D29'}
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
          
        </div>
      </section>
    </>
  );
}
